import React from "react";
import { Segment, Header } from "semantic-ui-react";
import { Field } from "redux-form";

function FormaDePago({ precios, setDescuentoAmpa, setIncrementoAmpa }) {
  return (
    <Segment>
      <Header as="h5">Forma de Pago:</Header>
      <div>
        <label>
          <Field
            id="ampa"
            name="formaDePago"
            type="radio"
            value="efectivo"
            component="input"
          />{" "}
          En Efectivo
        </label>
      </div>
      <div>
        <label>
          <Field
            id="ampa"
            name="formaDePago"
            type="radio"
            value="transferencia"
            component="input"
          />{" "}
          Ingreso o transferencia a la cuenta abajo indicada. Recuerde enviar el
          justificante de pago a la dirección escuelas@grupoaristas.com,
          indicando el nº de resguardo, para poder completar la inscripción.
        </label>
      </div>
    </Segment>
  );
}

export default FormaDePago;



// WEBPACK FOOTER //
// ./src/pages/inscripcionesConfirmadas/inscripcionConfirmada/formularioInscripcion/FormaDePago.jsx